"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Centralized logic for when to show an input error
function hasInputError(meta) {
  var invalid = meta.invalid,
      touched = meta.touched;
  return invalid && touched;
}

var _default = hasInputError;
exports["default"] = _default;